import type { AnalyticsSalesByHour } from "@/@types/Analytics";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SalesBarChartCard } from "./SalesBarChartCard";

interface SalesByHourChartProps {
  salesByHour?: AnalyticsSalesByHour[];
  isLoading: boolean;
}

export function SalesByHourChart({ salesByHour, isLoading }: SalesByHourChartProps) {
  const { t } = useTranslation("reports");

  const data = useMemo(
    () =>
      salesByHour?.map((item) => ({
        name: item.label,
        vendas: item.count,
        amount_formatted: item.amount_formatted,
      })) ?? [],
    [salesByHour],
  );

  return (
    <SalesBarChartCard
      title={t("reports:chart_sales_by_hour")}
      description={t("reports:chart_sales_by_hour_desc")}
      data={data}
      isLoading={isLoading}
      mobileHeight={250}
      desktopHeight={300}
      heightClassName="h-[250px] sm:h-[300px]"
    />
  );
}
